<!-- 拦截规则 -->
<template>
  <div class='page_content'>
    <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
      <interceptRuleAction v-if="showStatus" ref="interceptRuleAction" @drawerCancel="drawerCancel" @toDetail="toDetail" :actionData="actionData"></interceptRuleAction>
    </el-drawer>
    <div class="page_content_top">
      <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" :showRefresh="true" :buttonFlag="false"></v-button>
      <div class="page_content_top_line">
        <el-form :inline="true" :model="getRequestData" class="demo-form-inline" size="mini" label-width="100px">
          <el-form-item label="表单名称">
            <label slot="label" :style="$common.labelStyle('表单名称')" v-html="$common.htmlLabel('表单名称')"></label>
            <el-input  class="form_codition" v-model.trim="getRequestData.formName" clearable size="mini" placeholder="表单名称"></el-input>
          </el-form-item>
          <el-form-item label="规则名称">
            <label slot="label" :style="$common.labelStyle('规则名称')" v-html="$common.htmlLabel('规则名称')"></label>
            <el-input class="form_codition" v-model.trim="getRequestData.ruleName" clearable size="mini" placeholder="规则名称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="mini" @click="searchData">查询</el-button>
          </el-form-item>

        </el-form>
      </div>
    </div>
    <div class="page_content_center">
      <el-table size="mini" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row>
        <el-table-column align="center" label="选择操作" width="80">
          <template slot-scope="scope">
            <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
              <i class="el-icon-thumb"></i>
            </el-radio>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="formId" label="表单ID"></el-table-column>
        <el-table-column align="center" prop="formName" label="表单名称"></el-table-column>
        <el-table-column align="center" prop="ruleName" label="规则名称"></el-table-column>
        <el-table-column align="center" prop="ruleDesc" label="规则描述"></el-table-column>
        <el-table-column align="center" prop="ruleParam" label="参数"></el-table-column>
        <el-table-column align="center" prop="isNull" label="是否为空拦截">
          <template slot-scope="scope">
            <div>{{scope.row.isNull == "0"? "否":"是"}}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="isEnable" label="是否启用">
          <template slot-scope="scope">
            <div>{{scope.row.isEnable==0?'停用':'启用'}}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="ruleType" label="规则类型">
          <template slot-scope="scope">
            <div>{{scope.row.ruleType==0?'开关型':'开关+参数型'}}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="ruleResult" label="执行结果">
          <template slot-scope="scope">
            <div>{{scope.row.ruleResult==0?'拦截':'提醒'}}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page_content_bottom">
      <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>

    </div>
    <!-- 检索方案弹窗 -->
    <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
      <SearchScheme ref="searchScheme" :id="seId" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
    </el-dialog>
    <!-- 自定义设计 -->
    <customDesign ref="customDesign"></customDesign>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../byComponents/SearchScheme.vue";
import interceptRuleAction from "@/components/interceptRuleAction.vue";

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    SearchScheme,
    interceptRuleAction
  },
  data() {
    //这里存放数据
    return {
        tableHeight:0,
      getRequestData: {
        contact: "",  //	联系人
        ruleName: "",   //单位
        ormId: "",
        page: 1,
        rows: 30,
        start: new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000,
        end: new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1,
        formName:""
      },
      returnData: {
        pages: 0, // 总页数
        total: 0, // 总条数
        pageNum: 0, // 当前页数
        list: [],
      },
      buttonList: [],

      pageShowData: [],
      selectedDataIndex: 0,
      seTitle: "", //检索
      DialogVisible: false,
      seWidth: "0",
      seId: 0,
      showStatus: false,
      actionData: {}
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    "getRequestData.opmName": {
      handler: function (newValue, oldValue) {
        if (newValue == "") {
          this.getRequestData.opmId = "";
        }
      },
      deep: true,
    },
  },
  //方法集合
  methods: {
    // 子组件触发
    drawerCancel(e) {
      this.showStatus = false
      if (e == 1) this.getDataList()
    },
    // 点击穿透字段 传参单号
    toDetail(orderId) {
      if (orderId) {
        // 设置为true 打开穿透组件首页    
        var isPenetrate = true
        // 设置缓存 存入点击单号
        this.resetSetItem('penetrateOrderId', orderId);
        // 与父级跨域通信 传递isPenetrate参数
        window.parent.postMessage({ //向窗口发送MessageEvent消息
          cmd: 'returnFormJson',
          params: {
            isPenetrate
          } //参数
        }, '*');
      }
    },
    changeTime(val) {
      if (val) {
        var time = val + 24 * 60 * 60 * 1000 - 1;
        this.getRequestData.end = time;
      }
    },
    // 检索Id, 索引(表格中), 标识
    openSearch(sId, index) {
      this.focusIndex = index;
      this.DialogVisible = true;
      this.seId = sId;
    },
    //检索带回数据
    changeInputModel(val) {
      console.log("返hui", val);
      if (val != "" || val != undefined) {
        this.DialogVisible = false; //关闭商品检索窗口
        //赋值给当前行
        if (val.opmId) {
          this.getRequestData.opmId = val.opmId;
          this.getRequestData.opmName = val.opmName;
        }
      } else {
        this.DialogVisible = false;
        this.$message({
          message: "检索失败",
          type: "error",
        });
      }
      console.log("检索返后", this.sendDataInfo);
    },
    getSeWidth(e) {
      this.seWidth = e + "%";
    },
    getWidth(e) {
      this.exWidth = e + "%";
    },
    getSearchName(e) {
      this.seTitle = e;
    },

    isShowData(name, value) {
      switch (name) {
        case "bgmId":
          var dataInfo = sessionStorage.getItem("selectBusinessGoodsEntryInfo");

          if (dataInfo) {
            dataInfo = JSON.parse(dataInfo);
            this.getRequestData.bgmId = dataInfo.bgmId;
            this.getRequestData.bgmName = dataInfo.bgmName;
          }

          break;

        default:
          this.getRequestData[name] = value;
      }
    },
    // 获取数据列表
    async getPageInfo() {
      var pathId = parent.getMenuInfo(this.$route.path);
      let responseData = await this.$http.getJur({
        ids: [pathId.jurId],
      });
      if (responseData.status == 200) {
        this.pageShowData = responseData.result;
        var obj={}
                    if (this.pageShowData.jurHead) {
                        obj=this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform,'page',"rows",30)
                    }else{
                        obj=this.$common.getSearch(this.getRequestData,'start','end','page','rows',30)
                    }
                    for (const key in obj) {
                        this.$set(this.getRequestData,key,obj[key])
                    }
        this.formDataList = this.pageShowData.jurFormVoList
        this.getDataList();
        this.getButtonList();
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },

    // 动作集合
    actionSet(actionData) {
      switch (actionData.actionType) {
        case 0:
          this.showStatus = true
          this.actionData = {
            cate: 0,
            formData: this.formDataList,
            oldData: '',
            orderId: '',
            printSouce: '',
            printJurId: ''
          }
          break;
        case 1:
          if (this.returnData.list.length <= 0) {
            if (!dataInfo) {
              this.$message({
                message: "暂无数据",
                type: "error",
              });
              return false;
            }
          }
          if (!this.returnData.list[this.selectedDataIndex]) {
            this.$message({
              message: "请先选择您要操作的数据",
              type: "error",
            });
            return false;
          }
          var dataInfo = this.returnData.list[this.selectedDataIndex];
          this.showStatus = true
          this.actionData = {
            cate: 1,
            formData: this.formDataList,
            oldData: dataInfo,
            orderId: dataInfo.id,
            printSouce: '',
            printJurId: ''
          }
          break;
        case 2:
          this.delDataAction();
          break;
        case 3:
          this.submitData();
          break;
        case 15:
          this.openFormDesign()
          break;
      }
    },
    openFormDesign() {
      let pathInfo = parent.getMenuInfo(this.$route.path)
      this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
    },
    // 数据搜索
    searchData() {
      this.getRequestData.page = 1;
      this.getDataList();
    },
    // 数据翻页
    setDataPageNumber(val) {
      this.getRequestData.page = val;
      this.getDataList();
    },

    // 切换显示条数
    setDataPageSize(val) {
      this.getRequestData.page = 1;
      this.getRequestData.rows = val;
      this.getDataList();
    },

    // 获取数据列表
    async getDataList() {
      let responseData = await this.$http.getInterceptRoules(
        this.getRequestData
      );
      if (responseData.status == 200) {
        this.returnData.list = responseData.result.list;
        this.returnData.pages = responseData.result.pages;
        this.returnData.total = responseData.result.total;
        this.returnData.pageNum = responseData.result.pageNum;
        this.selectedDataIndex = 0;
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },

    // 删除数据
    delDataAction() {
      if (this.returnData.list.length <= 0) {
        if (!dataInfo) {
          this.$message({
            message: "暂无数据",
            type: "error",
          });
          return false;
        }
      }
      if (!this.returnData.list[this.selectedDataIndex]) {
        this.$message({
          message: "请先选择您要操作的数据",
          type: "error",
        });
        return false;
      }
      var dataInfo = this.returnData.list[this.selectedDataIndex];
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          var delData = {
            ids: [dataInfo.id],
          };
          let responseData = await this.$http.delAttributeAdjustment(delData);
          if (responseData.status == 200) {
            this.$message({
              type: "success",
              message: "删除成功!",
            });

            this.getDataList();
          } else {
            this.$message({
              message: responseData.message,
              type: "error",
            });
          }
        })
        .catch(() => { });
    },

    // 提交审核
    submitData() {
      if (this.returnData.list.length <= 0) {
        if (!dataInfo) {
          this.$message({
            message: "暂无数据",
            type: "error",
          });
          return false;
        }
      }
      if (!this.returnData.list[this.selectedDataIndex]) {
        this.$message({
          message: "请先选择您要操作的数据",
          type: "error",
        });
        return false;
      }
      var dataInfo = this.returnData.list[this.selectedDataIndex];
      this.$confirm("确定要提交审核吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          var delData = {
            businessKey: dataInfo.chamId,
          };
          let responseData = await this.$http.submitAttributeAdjustment(
            delData
          );
          if (responseData.status == 200) {
            this.$message({
              type: "success",
              message: "操作成功!",
            });

            this.getDataList();
          } else {
            this.$message({
              message: responseData.message,
              type: "error",
            });
          }
        })
        .catch(() => { });
    },

    // 获取按钮权限
    async getButtonList() {
      this.buttonList = await this.$common.getActionButton()
      
    },
//获取状态
    getIsGsp(str, val) {
      try {
        str && str.replace(/\\/g, "");
        let arr = JSON.parse(str);
        let len = arr.length;
        let newStr = "";
        for (let i = 0; i < len; i++) {
          if (arr[i].key == val) {
            newStr = arr[i].value;
            break;
          }
        }
        return newStr;
      } catch (ex) {
        return str;
      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    // this.getPageInfo();
    this.getDataList();
    this.getButtonList();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() { },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { this.tableHeight = this.$common.getTableHeight()}, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.table_content_tag {
  margin-right: 1rem;
}

.el-tabs--border-card_new {
  height: 85vh;
  overflow-y: scroll;
}
</style>